import React, { useState, useEffect } from 'react';
import { Phone, MapPin, Clock, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { restaurantInfo } from '../data/mockData';
import { trackCTAClick } from '../utils/analytics';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DAYS_ORDER = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [reviewStats, setReviewStats] = useState({ total_reviews: 273, average_rating: 4.6 });
  const [openingHours, setOpeningHours] = useState({});

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/settings/reviews`)
      .then(res => setReviewStats(res.data))
      .catch(() => {});
    axios.get(`${BACKEND_URL}/api/settings/hours`)
      .then(res => setOpeningHours(res.data.hours || {}))
      .catch(() => {});
  }, []);

  const handleSocialClick = (platform) => {
    trackCTAClick(`social_${platform}`);
  };

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
              <span className="text-white">LE </span>
              <span className="text-[#D4AF37]">COSMOS TACOS</span>
            </h3>
            <p className="text-white/70 mb-4">{restaurantInfo.tagline}</p>
            
            {/* Social Media - Primary Location */}
            <div className="mb-4">
              <p className="text-white/60 text-sm mb-3">Suivez-nous :</p>
              <div className="flex items-center space-x-3">
                {/* Snapchat */}
                <a
                  href="https://www.snapchat.com/add/cosmos_officiel"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleSocialClick('snapchat')}
                  className="bg-[#FFFC00] p-2 rounded-lg hover:opacity-80 transition-opacity"
                  title="Snapchat"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="black">
                    <path d="M12.206 2c1.368 0 2.605.391 3.512.922.897.527 1.527 1.261 1.818 2.01.182.464.273 1.108.273 1.915v.162c0 .398-.015.746-.044 1.047l.004.045c1.281.094 2.064.592 2.348 1.495.062.196.088.4.076.604-.012.204-.062.407-.15.6-.343.75-1.097 1.142-2.24 1.162-.063.002-.127.003-.19.003-.22 0-.417-.018-.598-.052-.06-.012-.119-.026-.177-.042-.08.16-.155.32-.225.48-.317.726-.539 1.345-.67 1.855-.028.11-.05.211-.066.303-.012.068-.023.131-.032.19-.012.082-.021.154-.026.217-.006.063-.009.119-.009.168 0 .264.054.477.162.637.108.16.299.3.574.42.275.12.668.23 1.178.33.115.023.21.09.27.186.06.096.082.21.062.32-.04.222-.121.427-.243.615-.242.376-.61.68-1.099.912-.978.464-2.377.697-4.198.697-1.82 0-3.22-.233-4.198-.697-.49-.232-.857-.536-1.1-.912-.121-.188-.202-.393-.242-.615-.02-.11.002-.224.062-.32.06-.096.155-.163.27-.186.51-.1.903-.21 1.178-.33.275-.12.466-.26.574-.42.108-.16.162-.373.162-.637 0-.049-.003-.105-.009-.168-.005-.063-.014-.135-.026-.217-.009-.059-.02-.122-.032-.19-.016-.092-.038-.193-.066-.303-.131-.51-.353-1.129-.67-1.855-.07-.16-.145-.32-.225-.48-.058.016-.117.03-.177.042-.181.034-.378.052-.598.052-.063 0-.127-.001-.19-.003-1.143-.02-1.897-.412-2.24-1.162-.088-.193-.138-.396-.15-.6-.012-.204.014-.408.076-.604.284-.903 1.067-1.401 2.348-1.495l.004-.045c-.029-.301-.044-.649-.044-1.047v-.162c0-.807.091-1.451.273-1.915.291-.749.921-1.483 1.818-2.01C9.601 2.391 10.838 2 12.206 2z"/>
                  </svg>
                </a>
                {/* Facebook */}
                <a
                  href="https://www.facebook.com/Le-Cosmos-Saint-Etienne"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleSocialClick('facebook')}
                  className="bg-[#1877F2] p-2 rounded-lg hover:opacity-80 transition-opacity"
                  title="Facebook"
                >
                  <Facebook size={20} className="text-white" />
                </a>
                {/* Instagram */}
                <a
                  href="https://www.instagram.com/le_cosmos42_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleSocialClick('instagram')}
                  className="bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] p-2 rounded-lg hover:opacity-80 transition-opacity"
                  title="Instagram"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                {/* TikTok */}
                <a
                  href="https://www.tiktok.com/@lecosmos42"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleSocialClick('tiktok')}
                  className="bg-black p-2 rounded-lg hover:opacity-80 transition-opacity border border-white/20"
                  title="TikTok"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>
            
            {/* HALAL Certificate - Sans background */}
            <div className="inline-block mb-4 bg-white p-3 rounded-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_cosmos-tacos/artifacts/518970yl_%2B24_Vector_Logo_Halal_Png_References__fast__logodesigns_-removebg-preview.png"
                alt="100% Halal Certifié"
                className="h-24 w-auto object-contain"
              />
            </div>
            
            <div className="flex items-center space-x-2 text-[#D4AF37]">
              <span className="text-2xl font-bold">{reviewStats.average_rating}</span>
              <span className="text-white/70 text-sm">/ 5 ({reviewStats.total_reviews} avis)</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-4">Contact</h4>
            <div className="space-y-3 text-white/70">
              <div className="flex items-start space-x-2">
                <Phone size={16} className="text-[#D4AF37] mt-1" />
                <div>
                  <a
                    href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
                    className="hover:text-[#D4AF37] transition-colors block"
                  >
                    {restaurantInfo.phone1}
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="text-[#D4AF37] mt-1" />
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(restaurantInfo.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  {restaurantInfo.address}
                </a>
              </div>
            </div>
          </div>

          {/* Horaires */}
          <div>
            <h4 className="font-bold text-white mb-4">Horaires</h4>
            <div className="space-y-2 text-sm text-white/70">
              {DAYS_ORDER.map((day) => (
                <div key={day} className="flex justify-between gap-4">
                  <span className="font-semibold text-white capitalize">{day}</span>
                  <span className="text-right">{openingHours[day] || '-'}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Livraison */}
          <div>
            <h4 className="font-bold text-white mb-4">Commander</h4>
            <div className="space-y-3">
              <a
                href={restaurantInfo.deliveryLinks.uberEats}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCTAClick('footer_uber_eats')}
                className="block bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg transition-colors text-center"
              >
                Uber Eats
              </a>
              <a
                href={restaurantInfo.deliveryLinks.deliveroo}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCTAClick('footer_deliveroo')}
                className="block bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg transition-colors text-center"
              >
                Deliveroo
              </a>
              <div className="text-sm text-white/70 mt-3">
                Livraison gratuite dès {restaurantInfo.freeDeliveryFrom}
              </div>
            </div>
          </div>
        </div>

        {/* Social & Copyright */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/60 text-sm">
              © {currentYear} Le Cosmos Saint-Étienne. Tous droits réservés.
            </div>
            
            {/* Legal Links */}
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-white/60">
              <Link to="/privacy" className="hover:text-[#D4AF37] transition-colors">
                Confidentialité
              </Link>
              <span>•</span>
              <Link to="/cookies" className="hover:text-[#D4AF37] transition-colors">
                Cookies
              </Link>
              <span>•</span>
              <Link to="/legal" className="hover:text-[#D4AF37] transition-colors">
                Mentions légales
              </Link>
              <span>•</span>
              <Link to="/terms" className="hover:text-[#D4AF37] transition-colors">
                CGU
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
